import { render, staticRenderFns } from "./CustomCalender.vue?vue&type=template&id=1d82c7a7&"
import script from "./CustomCalender.vue?vue&type=script&lang=js&"
export * from "./CustomCalender.vue?vue&type=script&lang=js&"
import style0 from "./CustomCalender.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports